import React from 'react'
import { Tabs } from '@bumaga/tabs'

const UITabWrapper = ({ children }) =>
  <Tabs>{children}</Tabs>

export default UITabWrapper
